import { Alert, AlertDescription, AlertTitle } from "@akuna/ui";
import { ShieldAlert } from "lucide-react";
import { useTranslation } from "react-i18next";

export function TeamAccessDenied() {
  const { t } = useTranslation("team");
  return (
    <div className="mx-auto w-full max-w-screen-xl px-4 py-8 md:px-6">
      <Alert variant="danger">
        <ShieldAlert className="h-4 w-4" aria-hidden="true" />
        <AlertTitle><h1 className="text-base font-semibold">{t("denied.title")}</h1></AlertTitle>
        <AlertDescription>{t("denied.description")}</AlertDescription>
      </Alert>
    </div>
  );
}
